import React from 'react';
import { FileText, AlertCircle } from 'lucide-react';

/**
 * Компонент для настройки параметров налогообложения
 */
const TaxSettingsSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-purple-50 dark:bg-purple-900/20 p-4 rounded-lg border border-purple-200 dark:border-purple-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <FileText className="w-5 h-5 mr-2 text-purple-600 dark:text-purple-400" />
        Налогообложение
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Ставка НДФЛ */}
        <div>
          <label htmlFor="incomeTaxRate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Ставка НДФЛ (%)
          </label>
          <div className="flex">
            <input
              type="text"
              id="incomeTaxRate"
              name="incomeTaxRate"
              value={formData.incomeTaxRate}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.incomeTaxRate ? 'input-error' : ''}`}
              placeholder="Введите ставку налога"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">%</span>
          </div>
          {errors.incomeTaxRate && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.incomeTaxRate}
            </p>
          )}
        </div>

        {/* Информационный блок */}
        <div className="md:col-span-2 bg-purple-100 dark:bg-purple-900/30 p-3 rounded-lg border border-purple-200 dark:border-purple-800">
          <div className="flex items-start">
            <AlertCircle className="w-5 h-5 text-purple-600 dark:text-purple-400 mr-2 flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-sm text-purple-700 dark:text-purple-300">
                <strong>Важно:</strong> Налогообложение применяется только в режиме "Рост стоимости с учетом инфляции" и рассчитывается 
                для разницы между конечной и начальной суммой.
              </p>
              <p className="text-xs text-purple-600 dark:text-purple-400 mt-1">
                В России стандартная ставка НДФЛ составляет 13% для налогового резидента (до 2024 года).
                С 2024 года для доходов свыше 5 млн рублей в год ставка НДФЛ составляет 15%.
              </p>
            </div>
          </div>
        </div>
      </div>
      
      <div className="mt-4">
        <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Доступные налоговые льготы
        </h4>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc pl-5 space-y-1">
          <li>Индивидуальный инвестиционный счет (ИИС) - налоговый вычет до 52 000 ₽ в год</li>
          <li>Долгосрочное владение ценными бумагами (более 3 лет) - льготное налогообложение</li>
          <li>Инвестиции в недвижимость (владение более 5 лет) - освобождение от НДФЛ</li>
        </ul>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-2">
          Данный калькулятор предоставляет упрощенный расчет без учета налоговых льгот и вычетов. 
          Для точного расчета налогов рекомендуется обратиться к налоговому консультанту.
        </p>
      </div>
    </div>
  );
};

export default TaxSettingsSection;